// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3024360","text":"_6ccddb2","singleLine":"_b1a18b5","title":"_2b4a16e","subTitle":"_acc49b7","voided":"_ec1e9e3"};